var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11C10 12.3261 9.47322 13.5979 8.53553 14.5355C7.59785 15.4732 6.32608 16 5 16C3.67392 16 2.40215 15.4732 1.46447 14.5355C0.526784 13.5979 0 12.3261 0 11C0 9.67392 0.526784 8.40215 1.46447 7.46447C2.40215 6.52678 3.67392 6 5 6C6.32608 6 7.59785 6.52678 8.53553 7.46447C9.47322 8.40215 10 9.67392 10 11Z",
    fill: "#00AFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.2C16 7.808 14.08 9.96 11.584 10.336V10.288C11.336 7.184 8.816 4.664 5.688 4.416H5.664C5.85055 3.18738 6.47126 2.0663 7.41355 1.25611C8.35584 0.445914 9.55729 0.000268199 10.8 0C11.4829 0 12.1591 0.134502 12.79 0.395826C13.4208 0.657151 13.9941 1.04018 14.477 1.52304C14.9598 2.00591 15.3428 2.57915 15.6042 3.21005C15.8655 3.84094 16 4.51713 16 5.2ZM2.872 0H0.8C0.36 0 0 0.36 0 0.8V2.872C0 3.584 0.864 3.944 1.368 3.44L3.44 1.368C3.936 0.864 3.584 0 2.872 0ZM13.128 16H15.2C15.64 16 16 15.64 16 15.2V13.128C16 12.416 15.136 12.056 14.632 12.56L12.56 14.632C12.064 15.136 12.416 16 13.128 16Z",
    fill: "#00AFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.0dd5beee36c4f6963f8c785c59800601.svg";
export { ForwardRef as ReactComponent };